import React, { useEffect } from 'react';
import { SEOConfig } from '../utils/seoConfig';

interface SEOHeadProps {
  config: SEOConfig;
}

/**
 * Component that renders JSON-LD schema markup
 * Should be placed in the page component to inject structured data
 */
const SEOHead: React.FC<SEOHeadProps> = ({ config }) => {
  useEffect(() => {
    if (config.schema) {
      // Remove existing schema script if present
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.remove();
      }

      // Create and inject new schema script
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(config.schema);
      document.head.appendChild(script);

      return () => {
        // Cleanup: remove schema on component unmount
        if (script && script.parentNode) {
          script.parentNode.removeChild(script);
        }
      };
    }
  }, [config.schema]);

  return null;
};

export default SEOHead;